const languages = {
	spanish: {
		bannerTitle:
			"Desarrollamos soluciones para una gestión más fácil y rápida de su",
		bannerYellowSpan: "flota comercial",
		bannerBoldText:
			"Juntos generamos protección y gestión de activos de manera rápida y fácil desde cualquier dispositivo.",
		bannerButtonContent: "SOLICITE UNA PROPUESTA",
		acercaYellowTitle: "ABOUT FORSIGHT GPS",
		acercaBoldText:
			"20 años visionando y desarrollando soluciones para la gestión de activos",
		acercaText:
			"Foresight es mucho más que una empresa de desarrollo de software, somos el aliado tecnológico para empresas que quieren innovar y necesitan sensorizar o rastrear sus activos o de terceros para una mejor gestión y protección de los mismos.",
		acercaButtonContent: "CONOZCA MÁS DE FORESIGHT GPS",
		beneficiosYellowTitle: "BENEFICIOS",
		beneficiosBoldText:
			"Controlar y rastrear activos nunca ha sido tan fácil con la innovación tecnológica que Foresight ofrece",
		bienestarCardTitle: "Seguridad y Bienestar",
		bienestarCardContent:
			"Ofrecemos soluciones que se adaptan a las necesidades de su negocio para el bienestar y seguridad de sus activos comerciales.",
		costosCardTitle: "Reducción de Costos",
		costosCardContent:
			"Foresight GPS le permite tener control sobre sus activos móviles y el estado en el que operan en cualquier momento a través de nuestra plataforma G-Evolution.",
		tecnologiaCardTitle: "Innovación Tecnológica",
		tecnologiaCardContent:
			"Gestione su flota de manera rápida y fácil desde cualquier dispositivo con nuestras innovadoras plataformas de rastreo.",
		beneficiosButtonContent: "BENEFICIOS REALES PARA SU NEGOCIO",
		serviciosYellowTitle: "PLATAFORMA",
		serviciosBoldText:
			"Sistema de gestión y control de activos, flotas y personas basado en geolocalización GPS y GPRS.",
		serviciosFirstCardTitle: "Manejo y Gestión de Flotas Comerciales",
		serviciosFirstCardContent:
			"Nuestra plataforma se adapta a sus necesidades y le permite gestionar los valores más importantes de su flota comercial.",
		serviciosFirstCardLink:
			"Monitoree y gestione sus valores más importantes en tiempo real.",
		serviciosSecondCardTitle: "Seguimiento de Personas VIP y Activos móviles",
		serviciosSecondCardContent:
			"Foresight GPS cuenta con seguimiento profesional y monitoreo para personal VIP y/o familiares en tiempo real.",
		serviciosSecondCardLink:
			"Monitoree y gestione sus valores más importantes en tiempo real.",
		serviciosThirdCardTitle:
			"Software llave en mano y marca blanca, listo para ser utilizado",
		serviciosThirdCardContent:
			"Podemos personalizar G-Evolution con todos los elementos de su marca para dar una mejor experiencia.",
		serviciosThirdCardLink: "Nos adaptamos a las necesidades de su negocio.",
		solucionesYellowTitle: "CARACTERISTICAS",
		solucionesBoldText:
			"G-Evolution crece y evoluciona contigo con una amplia gama de características y opciones flexibles",
		solucionesBoldContent:
			"Personalización, adaptación a cualquier tamaño y demanda de industrias, empresas, negocios, activos personales y familiares.",
		solucionesButtonContent: "BENEFICIOS REALES PARA SU NEGOCIO",
		solucion_1Title: "Rastreo en tiempo real",
		solucion_1Content:
			"El objetivo principal de G-Evolution es el rastreo eficiente y preciso de cualquier activo o persona en las condiciones más adversas.",
		solucion_2Title: "Módulo de mantenimiento preventivo",
		solucion_2Content:
			"En Foresight GPS contamos con equipo especializado en el desarrollo de aplicaciones móviles.",
		solucion_3Title: "Gestión de combustible",
		solucion_3Content:
			"La implementación de esta disciplina en Foresight GPS incluye: el seguimiento de vehículos, remolques y contenedores, gestión de flotas y muchos otros.",
		solucionLink: "CONOCE MÁS",
		formYellowTitle: "SOLICITE COTIZACIÓN",
		formTitle:
			"Nuestras soluciones y servicios ofrecen una amplia gama de características y opciones flexibles",
		formRightText: "Gestione su flota comercial de manera rápida y fácil.",
		formikField_1: "Nombre:",
		formikField_2: "Email:",
		formikField_3: "País:",
		formikField_4: "Compañía:",
		formikField_5: "Ciudad:",
		formikField_6: "Tamaño de Flota:",
		formikField_7: "¿Cómo se enteró de nosotros? *Opcional.",
		formButtonText: "¡Solicita tu cotización!",
	},
	english: {
		bannerTitle: "Developing the future with IoT and satellite tracking for ",
		bannerYellowSpan: "innovative companies",
		bannerBoldText:
			"We develop solutions for easier and faster management of your commercial fleet Protect and manage your mobile assets quickly and easily from any device.",
		bannerButtonContent: "REQUEST A PROPOSAL",
		acercaYellowTitle: "ABOUT FORSIGHT GPS",
		acercaBoldText:
			"20 years envisioning and developing solutions for asset management",
		acercaText:
			"Foresight is much more than a software development company, we are the technological ally for companies that want to innovate and need to sensorize or track their or third-party assets for better management and protection of them.",
		acercaButtonContent: "LEARN MORE ABOUT FORESIGHT GPS",
		beneficiosYellowTitle: "BENEFITS",
		beneficiosBoldText:
			"Controlling and tracking assets has never been easier with the technological innovation that Foresight offers",
		bienestarCardTitle: "Safety and Well-being",
		bienestarCardContent:
			"We offer solutions that are tailored to the needs of your business for the well-being and security of your business assets.",
		costosCardTitle: "Costs reduction",
		costosCardContent:
			"Foresight GPS allows you to have control over your mobile assets and the state in which they operate at any time through our G-Evolution platform.",
		tecnologiaCardTitle: "Technological innovation",
		tecnologiaCardContent:
			"Manage your fleet quickly and easily from any device with our innovative tracking platforms.",
		beneficiosButtonContent: "REAL BENEFITS FOR YOUR BUSINESS",
		serviciosYellowTitle: "PLATFORM",
		serviciosBoldText:
			"Management and control system for assets, fleets and people based on GPS and GPRS geolocation.",
		serviciosFirstCardTitle: "Management and Commercial Fleet Management",
		serviciosFirstCardContent:
			"Our platform adapts to your needs and allows you to manage the most important values ​​of your commercial fleet.",
		serviciosFirstCardLink:
			"Monitor and manage your most important values ​​in real time.",
		serviciosSecondCardTitle: "Tracking VIP People and Mobile Assets",
		serviciosSecondCardContent:
			"Foresight GPS has professional tracking and monitoring for VIP staff and / or family members in real time.",
		serviciosSecondCardLink:
			"Monitor and manage your most important values ​​in real time.",
		serviciosThirdCardTitle: "Turnkey, white label software, ready to use",
		serviciosThirdCardContent:
			"We can customize G-Evolution with all the elements of your brand to give a better experience.",
		serviciosThirdCardLink: "We adapt to the needs of your business.",
		solucionesYellowTitle: "FEATURES",
		solucionesBoldText:
			"G-Evolution grows and evolves with you with a wide range of flexible features and options",
		solucionesBoldContent:
			"Personalization, adaptation to any size and demand of industries, companies, businesses, personal and family assets.",
		solucionesButtonContent: "REAL BENEFITS FOR YOUR BUSINESS",
		solucion_1Title: "Real-time tracking",
		solucion_1Content:
			"The main objective of G-Evolution is the efficient and precise tracking of any asset or person in the most adverse conditions.",
		solucion_2Title: "Preventive maintenance module",
		solucion_2Content:
			"At Foresight GPS we have a team specialized in the development of mobile applications.",
		solucion_3Title: "Fuel management",
		solucion_3Content:
			"The implementation of this discipline in Foresight GPS includes: vehicle, trailer and container tracking, fleet management and many others.",
		solucionLink: "LEARN MORE",
		formYellowTitle: "REQUEST A QUOTE",
		formTitle:
			"Our solutions and services offer a wide range of features and flexible options",
		formRightText: "Manage your commercial fleet quickly and easily.",
		formikField_1: "Name:",
		formikField_2: "Email:",
		formikField_3: "Country:",
		formikField_4: "Company:",
		formikField_5: "City:",
		formikField_6: "Fleet Size:",
		formikField_7: "How did he find out about us? *Optional.",
		formButtonText: "¡Request a quote!",
	},
};

export default languages;
